import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/pczxLogin'
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/error/errorPage.vue')
  },
  {
    path: '/homeIndex',
    component: () => import('../views/homeIndex.vue')
  },
  {
    path: '/chnEngLogin',
    component: () => import('../views/loginRegist/chnEngLogin.vue')
  },
  {
    path: '/pczxLogin',
    meta: {
      title: 'AI电竞大赛 × 拼词之星'
    },
    component: () => import('../views/loginRegist/pczxLogin.vue')
  },
  {
    path: '/pczxNewLogin',
    meta: {
      title: 'AI电竞大赛 × 拼词之星'
    },
    component: () => import('../views/loginRegist/pczxLogin.vue')
  },
  {
    path: '/chnEngRegist',
    component: () => import('../views/loginRegist/chnEngRegist.vue')
  },
  {
    path: '/individualPapersList',
    component: () => import('../views/individual/individualPapersList')
  },
  {
    path: '/individualPapersDetail',
    component: () => import('../views/individual/individualPapersDetail.vue')
  },
  {
    path: '/itsoRegist',
    component: () => import('../views/itso/itsoRegist.vue')
  },
  {
    path: '/instructionManual',
    component: () => import('../views/other/instructionManual.vue')
  },
  {
    path: '/privacyPolicy',
    component: () => import('../views/privacyPolicy.vue')
  },
  {
    path: '/teacher',
    component: () => import('../views/spellingStar/homePage.vue'),
    meta: {
      title: 'AI电竞大赛 × 拼词之星'
    },
    redirect: 'welcome',
    children: [
      {
        path: '/welcome',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/welcomePage.vue')
      }, {
        path: '/studyPlan',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        // component: () => import('../views/studyPlan/studyPlanTabHome.vue')
        component: () => import('../views/studyPlan/studyPlanIndex.vue')
      }, {
        path: '/userInfo',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/userInfo.vue')
      }, {
        path: '/wordList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/studyPlan/wordList.vue')
      }, {
        path: '/class',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/classList.vue')
      }, {
        path: '/role',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/roleList.vue')
      }, {
        path: '/course',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/courseList.vue')
      }, {
        path: '/result',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/resultList.vue')
      }, {
        path: '/activities',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/activitiesList.vue')
      }, {
        path: '/activityPage',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/activityPage.vue')
      }, {
        path: '/scfyWordList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/ai/scfyWordList.vue')
      }, {
        path: '/spoken',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/spokenList.vue')
      }, {
        path: '/listening',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/listeningList.vue')
      }, {
        path: '/writen',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/writenList.vue')
      }, {
        path: '/reading',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/readingList.vue')
      }, {
        path: '/student',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/studentList.vue')
      }, {
        path: '/classRank',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/rank/classList.vue')
      }, {
        path: '/rank',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/rank/cardList.vue')
      }, {
        path: '/gradeRank',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/rank/gradeList.vue')
      }, {
        path: '/stuRank',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/rank/studentList.vue')
      }, {
        path: '/planRank',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/result/rank/studentRankPlan.vue')
      }, {
        path: '/aiArea',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/areaList.vue')
      }, {
        path: '/aiAreaEdit',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/areaEdit.vue')
      }, {
        path: '/aiMatch',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/matchList.vue')
      }, {
        path: '/matchGameDetail',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/matchGameDetail.vue')
      }, {
        path: '/matchGameDetailSchool',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/matchGameDetailSchool.vue')
      }, {
        path: '/aiMatchEdit',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/matchEdit.vue')
      }, {
        path: '/aiMatchSchoolEdit',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/matchSchoolEdit.vue')
      }, {
        path: '/rewardList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/rewardList.vue')
      }, {
        path: '/getEvalunationList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/evalunation/getEvalunationList.vue')
      }, {
        path: '/orderIndex',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/order/homeData.vue')
      },
      {
        path: '/orderList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/order/orderList.vue')
      },
      {
        path: '/couponList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/coupon/couponList.vue')
      },
      {
        path: '/productCouponList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/coupon/productCouponList.vue')
      },
      {
        path: '/couponBList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/coupon/couponBList.vue')
      },
      {
        path: '/couponListDetail',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/coupon/detail.vue')
      },
      {
        path: '/channelList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/channel/channelList.vue')
      },
      {
        path: '/organizationManage',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/organizationManage.vue')
      },
      {
        path: '/organizationList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/organizationList.vue')
      },
      {
        path: '/organizationDetail',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/organizationDetail.vue')
      },
      {
        path: '/examineList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/examine/examineList.vue')
      },
      {
        path: '/examineDetail',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/examine/examineDetail.vue')
      },
      {
        path: '/paymentList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/payment/paymentList.vue')
      },
      {
        path: '/paymentDetail',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/payment/paymentDetail.vue')
      },
      {
        path: '/channelSelect',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/channel/channelSelect.vue')
      },
      {
        path: '/signupList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/signupList.vue')
      }, {
        path: '/signupListSchool',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/signupListSchool.vue')
      }, {
        path: '/referee', // 原裁判系统赛事列表页面
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/referee/refereeMatchList.vue')
      }, {
        path: '/refereeNew', // 新裁判系统页面
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/referee/refereeMatchNew.vue')
      }, {
        path: '/refereePage',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/referee/refereePage.vue')
      }, {
        path: '/refereePageSchool',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/referee/refereePageSchool.vue')
      }, {
        path: '/roomStudentList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/referee/roomStudentList.vue')
      }, {
        path: '/cardList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/lexicon/productCard.vue')
      }, {
        path: '/lexiconList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/lexicon/lexiconList.vue')
      }, {
        path: '/lexiconWords',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/lexicon/wordList.vue')
      }, {
        path: '/userList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/userList.vue')
      }, {
        path: '/officialUserList',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/officialUserList.vue')
      }, {
        path: '/userDataInfo',
        meta: {
          title: 'AI电竞大赛 × 拼词之星'
        },
        component: () => import('../views/spellingStar/AICompetition/userDataInfo.vue')
      }

    ]
  },
  // **************** */ bigScreen Page start****************
  // 大屏相关页面在这里写
  {
    path: '/showTimePage',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/showTime.vue')
  },
  // 大屏相关页面在这里写----------------新
  {
    path: '/showTimePageSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/showTimeSchool.vue')
  },
  {
    path: '/videoPage',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/videoList.vue')
  },
  {
    path: '/screenRank',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/rankList.vue')
  },
  {
    path: '/nationalRankList',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/nationalRankList.vue')
  }, {
    path: '/screenRankSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/rankListSchool.vue')
  }, {
    path: '/pointsRankPage',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/pointsRankPage.vue')
  }, {
    path: '/pointsRankPageSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/pointsRankPageSchool.vue')
  }, {
    path: '/live2D',
    component: () => import('../views/spellingStar/live2D.vue')
  },
  {
    path: '/screenFinal',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/final.vue')
  },
  {
    path: '/screenFinalSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/final-school.vue')
  },
  {
    path: '/mifeng',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/component/ai/mifengDemo.vue')
  },
  {
    path: '/screenFinalGame',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/final-game.vue')
  },
  {
    path: '/screenFinalGameSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/final-game-school.vue')
  },
  {
    path: '/screenRyjfsGame',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/ryjfs-game.vue')
  },
  {
    path: '/screenWzbzbsGame',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/wzbzbs-game.vue')
  },
  {
    path: '/screenWzbzbsGameSchool',
    component: () => import('../views/spellingStar/AICompetition/bigScreen/wzbzbs-game-school.vue')
  },
  // **************** */ bigScreen Page end****************
  // 手册
  {
    path: '/book',
    name: 'book',
    component: () => import('@/views/spellingStar/AICompetition/book.vue'),
    meta: {
      title: '教师端使用手册'
    }
  },
  {
    path: '/studentBook',
    name: 'studentBook',
    component: () => import('@/views/spellingStar/AICompetition/studentBook.vue'),
    meta: {
      title: '教师端使用手册'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  }
})
// 挂载导航路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  // const whiteList = [
  //   '/screenRank'
  // ]
  // if (whiteList.includes(to.path)) return next()
  // if (!localStorage.getItem('Authorization')) return next('/homeIndex')
  next()
})
export default router
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
